#@import Booking.Helpers
#@import Booking.Models.Time
#@import Booking.Collections.Base
#@export Booking.Collections.Availability

class Booking.Collections.Availability extends Booking.Collections.Base
  model: Booking.Models.Time

  url: ->
    "#{Booking.rootUrl}/availability"

  parse: ({segments}) ->
    @meta('browserInMerchantTimezone', moment().utcOffset() is moment().tz(@getTimezone()).utcOffset())
    segments

  # Get all available times in the collection corresponding to a date
  getTimesByDate: (day) ->
    {start, end} = Booking.Helpers.getTimestampDayRange(day)
    @chain()
      .filter((time) -> start <= time.start().unix() <= end)
      .sortBy((model) -> model.start().unix())
      .value()

  hasTimesAtDate: (day) ->
    {start, end} = Booking.Helpers.getTimestampDayRange(day)
    time = @find (time) -> start <= time.start().unix() <= end
    return time?

  hasTimesInMonth: (month) ->
    {start, end} = Booking.Helpers.getTimestampMonthRange(moment(month).startOf('month'))
    hasTimes = @some (time) -> start <= time.start().unix() <= end
    return hasTimes

  hasTime: (timestamp) ->
    throw new Error 'Booking.Helpers.hasTime expects a timestamp' unless _.isFinite(timestamp)
    time = @find (time) -> time.start().unix() is timestamp
    return time?

  getSelectedDates: ->
    @chain()
      .filter((time) -> time.isSelected())
      .map((time) -> time.start().format('YYYY-MM-DD'))
      .uniq()
      .value()

  # Get all selected times in the collection
  getSelectedTimes: ->
    @filter (model) -> model.isSelected()

  # Get all selected times in the collection corresponding to a date
  getSelectedTimesByDate: (day) ->
    {start, end} = Booking.Helpers.getTimestampDayRange(day)
    @chain()
      .filter((time) -> time.isSelected() and start <= time.start().unix() <= end)
      .sortBy((model) -> model.start().unix())
      .value()

  # Get next date with availability
  # Returns a Moment Object
  getNextDateWithAvailability: ->
    date = Booking.Helpers.getNowInTimezone(@getTimezone())

    for num in [1...90]
      return date if @hasTimesAtDate(date)
      date.add(1, 'days')

    return null

  # Get next date with availability at a specific time
  # Returns a unix timestamp
  getNextDateWithAvailabilityAtTime: (timeString) ->
    # `today` is built from the customer's timezone
    today = Booking.Helpers.getNowInTimezone(@getTimezone()).format('YYYY-MM-DD')
    # `dateMoment` is `today` plus the time in the merchant's timezone + 1 day. (tomorrow's availability)
    dateMoment = Booking.Helpers.timezonedDatetime("#{today}T#{timeString}", @getTimezone()).add(1, 'day')
    timestamp = dateMoment.unix()

    for num in [1...90]
      return dateMoment if @hasTime(timestamp)
      dateMoment.add(1, 'days')
      timestamp = dateMoment.unix()

    return null

  # Get next date from the date selected with availability at a specific time
  # Returns a unix timestamp
  getNextDateWithAvailabilityAtTimeFromSpecificDate: (date, timeString) ->
    # `dateMoment` is `selected date` plus + 1 day.
    dateMoment = date.add(1, 'day')
    timestamp = dateMoment.unix()

    for num in [1...90]
      return dateMoment if @hasTime(timestamp)
      dateMoment.add(1, 'days')
      timestamp = dateMoment.unix()

    return null
